import { message } from 'antd';
import axios from 'axios';
import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DOCCHAT_ROOT_URL } from '../../config';
import { getValidAccessToken } from '../../utils/authUtils';
import { useRecordFileName } from './useRecordFileName';
import { useSelectedUploadData } from './useSelectedUploadData';

export const useExportDocument = (getUrl = () => '') => {
  const [searchParams] = useSearchParams();
  const { recordType } = useSelectedUploadData();
  const [loading, setLoading] = useState(false);

  const filename = useRecordFileName();

  const handleExport = useCallback(
    async ({ export_format, preset_id, run_id, fileNameSuffix = '' }) => {
      try {
        setLoading(true);
        const uuid = searchParams.get('uuid');

        if (!uuid) {
          console.error('UUID not found in URL');
          return;
        }
        const url = getUrl({
          recordType,
          uuid,
        });

        const finalFileName = `${filename}${fileNameSuffix}`;

        const response = await axios.get(`${DOCCHAT_ROOT_URL}/${url}/`, {
          params: {
            filename: finalFileName,
            export_format,
            preset_id,
            run_id,
          }, // ✅ send query params in GET
          headers: {
            Authorization: `Bearer ${await getValidAccessToken()}`,
          },
          responseType: 'blob', // if downloading a file
        });

        console.info('Export success:', response);

        // ✅ Create a downloadable link
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${finalFileName}.${export_format}`;
        document.body.appendChild(link);
        link.click();

        // cleanup
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        console.info('✅ File downloaded successfully!');
      } catch (error) {
        console.error('Export failed:', error);
        message.error(error.message);
      } finally {
        setLoading(false);
      }
    },
    [searchParams, recordType, filename, getUrl]
  );

  return {
    handleExport,
    exportRequestLoading: loading,
    recordInfoNotFound: recordType === '',
  };
};
